<div *ngIf="status < 6 && !fullEndDate" class="active badge">{{ statusLabel }}</div>
<div *ngIf="status < 6 && fullEndDate" class="warning badge">
  <mat-icon class="icon">access_time_filled</mat-icon>
  Afmelding per {{ fullEndDate | date: 'dd-MM-yyyy' }}
</div>
<div *ngIf="status >= 6" class="archived badge">{{ statusLabel }}</div>